import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data, Select3Data } from "../../../utils/common";

// Country - Get All
export const AllCountry = createAsyncThunk(
  "/master/countries",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllState = createAsyncThunk(
  "/master/states",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllState}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCities = createAsyncThunk(
  "/master/city",
  async ({ state_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllCities}?state_id=${state_id}&name=${name}`,
        {
          headers: {
            platform: process.env.REACT_APP_PLATFORM,
            appversion: process.env.REACT_APP_APP_VERSION,
          },
        },
      );

      return await Select2Data(res.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCartegory = createAsyncThunk(
  "/servicecategory",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCartegory}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });

      return await Select2Data(res.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBanners = createAsyncThunk(
  "/master/banners",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBanners);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllReviews = createAsyncThunk(
  "/master/reviews",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllReviews);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAboutUs = createAsyncThunk(
  "/master/aboutus",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAboutUs);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAdvantages = createAsyncThunk(
  "/master/advantages",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAdvantages);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPrivacyPolicyContent = createAsyncThunk(
  "/master/privacypolicycontents",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPrivacyPolicyContent);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPrivacyPolicy = createAsyncThunk(
  "/master/privacypolicies",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPrivacyPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Return Policy
export const AllReturnPolicyContent = createAsyncThunk(
  "/master/returnpolicycontents",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllReturnPolicyContent);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllReturnPolicy = createAsyncThunk(
  "/master/returnpolicies",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllReturnPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Refund Policy
export const AllRefundPolicyContent = createAsyncThunk(
  "/master/refundpolicycontents",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllRefundPolicyContent);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllRefundPolicy = createAsyncThunk(
  "/master/refundpolicies",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllRefundPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Shipping Policy
export const AllShippingPolicyContent = createAsyncThunk(
  "/master/shippingpolicycontents",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllShippingPolicyContent);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllShippingPolicy = createAsyncThunk(
  "/master/shippingpolicies",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllShippingPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTermconditionContent = createAsyncThunk(
  "/master/termsconditioncontents",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTermconditionContent);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTermcondition = createAsyncThunk(
  "/master/termsconditions",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTermcondition);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllShareholder = createAsyncThunk(
  "/master/shareholders",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllShareholder);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAppSetup = createAsyncThunk(
  "/master/appsetup",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAppSetup);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllStepToJoin = createAsyncThunk(
  "/master/steptojoins",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllStepToJoin);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCategories = createAsyncThunk(
  "common/masters/servicecategoryss",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCategories);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProfessions = createAsyncThunk(
  "common/masters/get-professionsss",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProfessions);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllPurchaseDate = createAsyncThunk(
  "/get-purchase-date",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPurchaseDate}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      return await Select2Data(res.data, "purchase_date");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCity = createAsyncThunk(
  "/master/cities",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}?name=${filter}`);

      return await Select2Data(res.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllDocumentType = createAsyncThunk(
  "/master/documents",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllDocumentType}?name=${filter}`);

      return await Select3Data(res.data, "document_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllOrderStatus = createAsyncThunk(
  "/master/orderStatus",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllOrderStatus);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCancellationContent = createAsyncThunk(
  "/master/cancellationpolicycontents",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCancellationContent);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCancellationPolicy = createAsyncThunk(
  "/master/cancellationgpolicies",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCancellationPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const channelPartnerCount = createAsyncThunk(
  "/master/patnerCount",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.channelPartnerCount);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_state: [],
    all_city: [],
    all_category: [],
    all_banners: [],
    all_review: [],
    all_about_us: [],
    all_advantages: [],
    all_privacy_policy_content: [],
    all_privacy_policy: [],
    all_terms_condition_content: [],
    all_terms_condition: [],
    all_share_holder: [],
    all_step_to_join: [],

    all_app_setup: [],
    all_categories: [],
    all_professions: [],
    all_purchase_date: [],
    all_cities: [],
    all_document_type: [],
    all_country: [],
    all_order_status: [],

    all_return_policy_content: [],
    all_return_policy: [],
    all_refund_policy_content: [],
    all_refund_policy: [],
    all_shipping_policy_content: [],
    all_shipping_policy: [],

    all_cancellation_policy_content: [],
    all_cancellation_policy: [],
    all_channel_partner_count: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Handling AllState actions

      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCities.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCities.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCities.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCartegory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCartegory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCartegory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBanners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBanners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banners = action.payload || [];
      })
      .addCase(AllBanners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllReviews.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllReviews.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_review = action.payload || [];
      })
      .addCase(AllReviews.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAboutUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAboutUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_about_us = action.payload || [];
      })
      .addCase(AllAboutUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAdvantages.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAdvantages.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_advantages = action.payload || [];
      })
      .addCase(AllAdvantages.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrivacyPolicyContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrivacyPolicyContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacy_policy_content = action.payload;
      })
      .addCase(AllPrivacyPolicyContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrivacyPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrivacyPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacy_policy = action.payload;
      })
      .addCase(AllPrivacyPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Return Policy

      .addCase(AllReturnPolicyContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllReturnPolicyContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_return_policy_content = action.payload;
      })
      .addCase(AllReturnPolicyContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllReturnPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllReturnPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_return_policy = action.payload;
      })
      .addCase(AllReturnPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Refund Policy

      .addCase(AllRefundPolicyContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRefundPolicyContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_refund_policy_content = action.payload;
      })
      .addCase(AllRefundPolicyContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllRefundPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRefundPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_refund_policy = action.payload;
      })
      .addCase(AllRefundPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Shipping Policy

      .addCase(AllShippingPolicyContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllShippingPolicyContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_shipping_policy_content = action.payload;
      })
      .addCase(AllShippingPolicyContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllShippingPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllShippingPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_shipping_policy = action.payload;
      })
      .addCase(AllShippingPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTermconditionContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermconditionContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_terms_condition_content = action.payload;
      })
      .addCase(AllTermconditionContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllTermcondition.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermcondition.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_terms_condition = action.payload;
      })
      .addCase(AllTermcondition.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllShareholder.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllShareholder.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_share_holder = action.payload;
      })
      .addCase(AllShareholder.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_app_setup = action.payload;
      })
      .addCase(AllAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllStepToJoin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllStepToJoin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_step_to_join = action.payload;
      })
      .addCase(AllStepToJoin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCategories.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategories.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_categories = action.payload;
      })
      .addCase(AllCategories.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProfessions.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProfessions.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_professions = action.payload;
      })
      .addCase(AllProfessions.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllPurchaseDate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPurchaseDate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_purchase_date = action.payload || [];
      })
      .addCase(AllPurchaseDate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_cities = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDocumentType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDocumentType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_document_type = action.payload || [];
      })
      .addCase(AllDocumentType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllOrderStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOrderStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_order_status = action.payload || [];
      })
      .addCase(AllOrderStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCancellationContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCancellationContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_cancellation_policy_content = action.payload;
      })
      .addCase(AllCancellationContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCancellationPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCancellationPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_cancellation_policy = action.payload;
      })
      .addCase(AllCancellationPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(channelPartnerCount.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(channelPartnerCount.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_channel_partner_count = action.payload;
      })
      .addCase(channelPartnerCount.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
